module.exports = __webpack_public_path__ + "img/Athletics.c7d0726b.png";